import { disputeDeflectionViewSchema } from "@redotech/redo-dispute-common/dispute-deflection-view-definition";
import {
  disputeDeflectionOutcome,
  disputeDeflectionSortableColumns,
} from "@redotech/redo-dispute-db-schema/dispute-deflection-definition";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import * as z from "zod";

// Merchant RESOLVE list: the team's dispute_deflection rows (RESOLVE inquiries we
// answered), filtered by outcome, sorted, paginated. Mirrors listDisputelyAlerts.
// rawRequest/responseBody are stripped by the view schema.
export const listDeflections = {
  name: "listDeflections" as const,
  input: z.object({
    outcomes: z.array(z.enum(disputeDeflectionOutcome)).optional(),
    limit: z.number().int().min(1).max(200).optional(),
    offset: z.number().int().min(0).optional(),
    sortBy: z.enum(disputeDeflectionSortableColumns).optional(),
    sortDirection: SortDirectionSchema.optional(),
  }),
  output: z.object({
    deflections: z.array(disputeDeflectionViewSchema),
    total: z.number().int(),
  }),
};
